export const DEVICE_MODELS = ['AT603', 'AT603D'];

export const TASK_STATUS = {
    RUNNING: { text: '运行中', tag: 'warning' },
    FINISHED: { text: '已完成', tag: 'success' },
    CANCELLED: { text: '已终止', tag: 'info' }
};

export const ITEM_STATUS = {
    PENDING: { text: '待下发', tag: 'info' },
    HARDWARE_CHECKING: { text: '硬件检查中', tag: 'primary' },
    DEVICE_NAME_SENT: { text: '设备名已下发', tag: 'warning' },
    COMMAND_SENT: { text: '命令已下发', tag: 'warning' },
    UPGRADING: { text: '升级中', tag: 'primary' },
    PROFILE_SETTING: { text: '码流设置中', tag: 'primary' },
    WAITING_CONDITION: { text: '等待条件', tag: 'danger' },
    SUCCESS: { text: '成功', tag: 'success' },
    FAILED: { text: '失败', tag: 'info' }
};

export function statusMeta(map, status) {
    return map[status] || { text: status || '--', tag: 'info' };
}
